/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from '@jutro/locale';

export default defineMessages({
    viewAllMyFollowUps: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.VIEW ALL MY FOLLOW UPS',
        defaultMessage: 'VIEW ALL MY FOLLOW UPS'
    },
    viewAllTasks: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.VIEW ALL TASKS',
        defaultMessage: 'VIEW ALL TASKS'
    },
    noFollowUpActivityFound: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.No follow-up activity found',
        defaultMessage: 'No follow-up activity found'
    },
    dueDate: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.DUE DATE',
        defaultMessage: 'DUE DATE'
    },
    customerName: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.CUSTOMER NAME',
        defaultMessage: 'CUSTOMER NAME'
    },
    product: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.PRODUCT',
        defaultMessage: 'PRODUCT'
    },
    policy: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.QUOTE/POL #',
        defaultMessage: 'QUOTE/POL #'
    },
    initiator: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.INITIATOR',
        defaultMessage: 'INITIATOR'
    },
    note: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.NOTE',
        defaultMessage: 'NOTE'
    },
    priority: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.PRIORITY',
        defaultMessage: 'PRIORITY'
    },
    loading: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.Loading...',
        defaultMessage: 'Loading...'
    },
    account: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.Account',
        defaultMessage: 'Account'
    },
    quoteToCompleteInPC: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.Quote has not been completed. The quote must be completed in PolicyCenter.',
        defaultMessage: 'Quote has not been completed. The quote must be completed in PolicyCenter.'
    },
    quoteNotCompleteCall: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.Quote has not been completed. Contact us at 1-800-255-0332 for assistance.',
        defaultMessage: 'Quote has not been completed. Contact us at 1-800-255-0332 for assistance.'
    },
    contactBookManager: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.Quote has not been completed. Please contact your Book Consolidation manager.',
        defaultMessage: 'Quote has not been completed. Please contact your Book Consolidation manager.'
    },
    quoteNotComplete: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.Quote is not complete',
        defaultMessage: 'Quote is not complete'
    },
    yesterday: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.Due Yesterday',
        defaultMessage: 'Due Yesterday'
    },
    today: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.Due Today',
        defaultMessage: 'Due Today'
    },
    tomorrow: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.Due Tomorrow',
        defaultMessage: 'Due Tomorrow'
    },
    due: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.Due date',
        defaultMessage: 'Due {date}'
    },
    agentFollowUps: {
        id: 'ml.gateway.views.ActivityReports.mlMyFollowUpsReportComponent.Agent Follow Ups',
        defaultMessage: 'Agent Follow Ups'
    }
});
